import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS, HttpClient, HttpClientModule } from '@angular/common/http';
import { NgModule, Optional, SkipSelf } from '@angular/core';
import { TranslateLoader, TranslateModule, TranslateService } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { HtcPopAlertComponent } from './components/htc-popalert.component';
import { AuthGuardService } from './services/auth-guard.service';
import { HtcCoreService } from './services/htc-core.service';
import { HtcHttpInterceptor } from './services/htc-http-interceptor';
import { HtcHttpService } from './services/htc-http.service';
import { HtcPopAlertService } from './services/htc-popalert.service';
import { HtcStateService } from './services/htc-state.service';
import { HtcStorageService } from './services/htc-storage.service';
import { PermissionGuardService } from './services/permission-guard.service';
import { PwaService } from './services/pwa-service.service';

// AOT compilation support
export function httpTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http);
}

@NgModule({
  imports: [
    HttpClientModule,
    CommonModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: httpTranslateLoader,
        deps: [HttpClient],
      },
    }),
  ],
  declarations: [HtcPopAlertComponent],
  exports: [HtcPopAlertComponent],
  providers: [
    HtcCoreService,
    HtcHttpService,
    HtcPopAlertService,
    HtcStorageService,
    HtcStateService,
    AuthGuardService,
    PermissionGuardService,
    PwaService,
    { provide: HTTP_INTERCEPTORS, useClass: HtcHttpInterceptor, multi: true },
  ],
})
export class CoreModule {
  constructor(
    @Optional()
    @SkipSelf()
    parentModule: CoreModule,
    translate: TranslateService
  ) {
    if (parentModule) {
      throw new Error('CoreModule is already loaded. Import it in the AppModule only');
    }

    translate.addLangs(['it', 'en']);
    const browserLang = translate.getBrowserLang();
    translate.use(browserLang.match(/it|en/) ? browserLang : 'en');
  }
}
